import { createAction, props } from "@ngrx/store";

const prefix = "[Delete Skill Type]";

export const requestDeleteSkillType = createAction(
  `${prefix} Request Delete Skill Type`,
  props<{ skillTypeId: string }>(),
);
